module.exports = __webpack_public_path__ + "img/saving.abcb5f93.png";